module.exports = __webpack_public_path__ + "img/threat-analytics-traffic.c71036f2.png";